export const projects = {
  pageTitle: 'Nos Réalisations',
  pageSubtitle: 'Découvrez nos projets de rénovation réalisés à Bruxelles et ses environs',
  
  // Filters
  allCategories: 'Toutes les catégories',
  masonry: 'Maçonnerie',
  bathroom: 'Salle de bain',
  kitchen: 'Cuisine',
  painting: 'Peinture',
  carpentry: 'Menuiserie',
  complete: 'Rénovation complète',
  
  // Project Details
  location: 'Lieu',
  duration: 'Durée',
  category: 'Catégorie',
  
  // Project Note
  projectNote: 'Un projet réalisé avec soin, dans le respect des délais et du budget',
  
  // CTA
  ctaTitle: 'Votre projet est unique',
  ctaDescription: 'Chaque rénovation est différente. Parlons de la vôtre',
  ctaButton: 'Demander un devis gratuit',
  
  // Empty State
  noProjects: 'Aucun projet trouvé',
  noProjectsDescription: 'Aucun projet ne correspond à vos critères de recherche'
};